import React from "react";
import { Link } from "react-router-dom";
import { FiInstagram, FiFacebook, FiLinkedin, FiPhone, FiMail } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="border-t border-line bg-brand text-paper">
      <div className="max-w-content mx-auto px-6 py-14 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <img src="/assets/logo-icon.png" alt="" className="h-9 w-auto" />
              <span className="text-xl font-bold">Nirkana</span>
            </div>
            <p className="mt-3 max-w-xs text-sm text-paper/70">
              A single platform for planning life's occasions — starting
              with birthdays, built to grow into every celebration in
              between.
            </p>
            <div className="mt-5 flex gap-4 text-paper/70">
              <a href="https://instagram.com/nirkanagroups" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-paper">
                <FiInstagram size={18} />
              </a>
              <a href="https://facebook.com/nirkanagroup" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-paper">
                <FiFacebook size={18} />
              </a>
              <button type="button" aria-label="LinkedIn (coming soon)" disabled className="cursor-not-allowed opacity-50">
                <FiLinkedin size={18} />
              </button>
            </div>
          </div>

          <div>
            <p className="text-sm font-semibold">Events</p>
            <ul className="mt-3 space-y-2 text-sm text-paper/70">
              <li><Link to="/packages" className="hover:text-paper">Birthdays</Link></li>
              <li><Link to="/events" className="hover:text-paper">Baby showers</Link></li>
              <li><Link to="/events" className="hover:text-paper">Housewarmings</Link></li>
              <li><Link to="/events" className="hover:text-paper">Weddings</Link></li>
              <li><Link to="/events" className="hover:text-paper">Corporate events</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold">Company</p>
            <ul className="mt-3 space-y-2 text-sm text-paper/70">
              <li><Link to="/how-it-works" className="hover:text-paper">How it works</Link></li>
              <li><Link to="/about" className="hover:text-paper">About</Link></li>
              <li><Link to="/faq" className="hover:text-paper">FAQ</Link></li>
              <li><Link to="/careers" className="hover:text-paper">Careers</Link></li>
              <li><Link to="/contact" className="hover:text-paper">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold">Partners</p>
            <ul className="mt-3 space-y-2 text-sm text-paper/70">
              <li><Link to="/partners" className="hover:text-paper">ONDC network</Link></li>
              <li><Link to="/partners" className="hover:text-paper">Become a vendor</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-paper">Privacy policy</Link></li>
            </ul>
            <div className="mt-4 space-y-1.5 text-sm text-paper/70">
              <a href="tel:+919080924318" className="flex items-center gap-2 hover:text-paper">
                <FiPhone size={14} /> +91 90809 24318
              </a>
              <a href="mailto:info@nirkana.com" className="flex items-center gap-2 hover:text-paper">
                <FiMail size={14} /> info@nirkana.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-paper/15 pt-6 text-xs text-paper/60 sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {new Date().getFullYear()} Nirkana. All rights reserved.</p>
          <p>Chennai, Tamil Nadu · ONDC network partner</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
